import { useEffect, useState } from 'react';

import { apiMain } from 'services/apiService';

export const useUserFormCompletion = (userId?: string, groupId?: string) => {
  const [progress, setProgress] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userId || !groupId) return;

    const fetchCompletion = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiMain.get(
          `/forms/v1/analysis/completion/${userId}?group_id=${groupId}`
        );
        setProgress(response.data.completion);
      } catch (err: any) {
        setError('Erro ao buscar progresso');
        setProgress(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCompletion();
  }, [userId, groupId]);

  return { progress, loading, error };
};
